import classnames from 'classnames'
import { FORM_ERROR } from 'final-form'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'
import React, { useState, useEffect } from 'react'
import { Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import size from 'lodash/size'
import ReactTimeout from 'react-timeout'
import { compose } from 'recompose'
import { fetchCustomerData, updateCustomerData } from 'Lib/fetch'
import history from 'Lib/history'
import SubmitButton from '../Button/SubmitButton'
import CeoForm from '../Checkout/CeoForm'
import { LoadingIndicator } from '../Layout/LoadingIndicator'
import Section from '../Layout/Section'

const validate = values => {
  const errors = { ceo: {} }

  if (values.ceo.postcode && size(values.ceo.postcode) !== 5) {
    errors.ceo.postcode = 'invalidPostcode'
  }
  if (values.ceo.birthdate) {
    const datetime = DateTime.fromFormat(values.ceo.birthdate, 'dd.MM.yyyy')
    if (!datetime.isValid) {
      errors.ceo.birthdate = 'wrongDateFormat'
    } else if (datetime.plus({ years: 21 }) > DateTime.local()) {
      errors.ceo.birthdate = 'minAge'
    }
  }

  return errors
}

const Ceo = ({ setTimeout }) => {
  const { t } = useTranslation()
  const [success, setSuccess] = useState(false)
  const [customerData, setCustomerData] = useState({
    addresses: [],
  })

  const fetchData = async () => {
    try {
      const res = await fetchCustomerData()
      setCustomerData(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        history.push('/account/login')
      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const toggleSuccessMessage = () => {
    setSuccess(!success)
  }

  const onSubmit = async values => {
    try {
      await updateCustomerData(values)
      toggleSuccessMessage()
      setTimeout(toggleSuccessMessage, 1000)
      return null
    } catch (error) {
      return { [FORM_ERROR]: t('feedback.genericError') }
    }
  }

  if (!customerData.ceo) {
    return (
      <Section>
        <LoadingIndicator />
      </Section>
    )
  }

  return (
    <div className="grid-x grid-padding-x">
      <div className="cell small-12">
        <Form
          onSubmit={onSubmit}
          initialValues={customerData}
          validate={validate}
          render={({ handleSubmit, submitError, submitting }) => (
            <form
              onSubmit={handleSubmit}
              className={classnames('checkout', 'small-guter-form')}
              name="checkout"
            >
              <CeoForm />

              <SubmitButton
                style={{ marginTop: '1em' }}
                height={59}
                fetching={submitting}
                disabled={submitting || success}
              >
                {success
                  ? t('common:feedback.saved')
                  : t('common:actions.save')}
              </SubmitButton>
              {submitError && (
                <div>
                  <span className="authError">{submitError}</span>
                </div>
              )}
            </form>
          )}
        />
      </div>
    </div>
  )
}

const enhance = compose(withRouter, ReactTimeout)

Ceo.propTypes = {
  setTimeout: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired, // eslint-disable-line
}

export default enhance(Ceo)
